export const diffObjects = (prev, curr, basePath = '') => {
    const added = [];
    const removed = [];
    const changed = [];
    const isObject = (v) => typeof v === 'object' && v !== null && !Array.isArray(v);
    if (!isObject(prev) || !isObject(curr)) {
        if (prev !== curr) {
            changed.push({
                'path': basePath,
                'before': prev,
                'after': curr,
            });
        }
        return { added, removed, changed };
    }
    const prevObj = prev;
    const currObj = curr;
    const prevKeys = new Set(Object.keys(prevObj));
    const currKeys = new Set(Object.keys(currObj));
    for (const key of currKeys) {
        if (!prevKeys.has(key)) {
            added.push({
                'path': basePath ? `${basePath}.${key}` : key,
                'after': currObj[key],
            });
        }
    }
    for (const key of prevKeys) {
        if (!currKeys.has(key)) {
            removed.push({
                'path': basePath ? `${basePath}.${key}` : key,
                'before': prevObj[key],
            });
        }
    }
    for (const key of prevKeys) {
        if (currKeys.has(key)) {
            const childPath = basePath ? `${basePath}.${key}` : key;
            const childDiff = diffObjects(prevObj[key], currObj[key], childPath);
            added.push(...childDiff.added);
            removed.push(...childDiff.removed);
            changed.push(...childDiff.changed);
        }
    }
    return { added, removed, changed };
};
